import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OauthService {
  private http = inject(HttpClient);
  private apiUrl = `${environment.apiUrl}/api/auth/login`;

  login(username: string, password: string): Observable<{ success: boolean; token?: string; error?: string }> {
    const payload = {
      email: username,
      password: password
    };

    return this.http.post<{ access_token: string }>(this.apiUrl, payload).pipe(
      map(res => {
        localStorage.setItem('jwt_token', res.access_token);
        return { success: true, token: res.access_token };
      })
    );
  }

  logout(): Observable<void> {
    return this.http.get<void>(`${environment.apiUrl}/api/users/logout`).pipe(
      map(() => {
        localStorage.removeItem('jwt_token');
        return;
      })
    );
  }

  getCurrentUser(): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/api/users/me`);
  }

  refreshToken(): Observable<{ access_token: string }> {
    const refresh_token = localStorage.getItem('jwt_token'); // Adjust if refresh token is stored differently
    return this.http.post<{ access_token: string }>(`${environment.apiUrl}/api/auth/refresh`, {refresh_token: refresh_token}).pipe(
      map(res => {
        localStorage.setItem('jwt_token', res.access_token);
        return res;
      })
    );
  }

  clearToken(): void {
    localStorage.removeItem('jwt_token');
  }

  getToken(): string | null {
    return localStorage.getItem('jwt_token');
  }
}
